import { Box, BoxProps, Typography } from '@mui/material';

export function EmptyView({ title, sx = [], ...boxProps }: { title?: string } & BoxProps) {
    return (
        <Box
            sx={[
                {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: 94,
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...boxProps}
        >
            <Typography>{title}</Typography>
        </Box>
    );
}
